import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import PlanUpgradeReportHomeSection from "../../components/Reports/planUpgradeReport/PlanUpgradeReportHomeSection";
import PurchaseReportHomeSection from "../../components/Reports/purchaseReport/PurchaseReportHomeSection";

export const PurchaseReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
        <Loader start={isLoading} />
        <Page>
            <PurchaseReportHomeSection 
                setIsLoading={setIsLoading} 
                isLoading={isLoading}
            />
        </Page>
        </>
    )
}

export default PurchaseReport;